<script lang="ts">
	import type { PoiImages } from '$lib/components/pois/types';
	import type { ClassValue } from 'svelte/elements';
	import Image from '$lib/components/atoms/image/Image.svelte';

	interface Props {
		sizes?: string;
		alt: string;
		eager?: boolean;
		fallbackSrc?: string;
		width?: string;
		height?: string;
		objectFit?: string;
		src?: string;
		class?: ClassValue;
		srcset: PoiImages;
	}

	const {
		sizes,
		alt,
		eager = false,
		fallbackSrc,
		width,
		height,
		objectFit,
		src,
		class: classes,
		srcset: srcs,
	}: Props = $props();

	const srcset = $derived(Object.entries(srcs)
		.filter(([width]) => width.startsWith('w'))
		.map(([width, src]) => `${src} ${width.replace('w', '')}w`)
		.join(', '));

</script>

<Image
	src={src || (srcs.w320 ?? '')}
	{alt}
	{eager}
	{fallbackSrc}
	{width}
	{height}
	{objectFit}
	class={classes}
	{srcset}
	{sizes}
/>
